// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: {
        themes: {
            light: {
                primary: '#11254D',
                primaryLighter: '#11455B',
                secondary: '#17c1aa',
                accent: '#ff9800',
                info: '#66a5ad',
                error: '#F4511E',
                goldColor: '#cda252',
                greyColor: '#BDBDBD',
                lightSeaGreen: '#20b2aa',
                indianRed: '#cd5c5c',
                booksBackground: '#e3dec9',
            },
            dark: {
                primary: '#003b46',
                secondary: '#07575b',
                accent: '#ff9800',
                info: '#66a5ad',
                error: '#F4511E'
            }
        },
    }
}

export default new Vuetify(opts)